import { render, staticRenderFns } from "./VerifyEmployeeRegistrationDialogStep2.vue?vue&type=template&id=4b5ecc6b&scoped=true"
import script from "./VerifyEmployeeRegistrationDialogStep2.vue?vue&type=script&lang=js"
export * from "./VerifyEmployeeRegistrationDialogStep2.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmployeeRegistrationDialogStep2.vue?vue&type=style&index=0&id=4b5ecc6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ecc6b",
  null
  
)

export default component.exports